import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// context 
import { useData } from '../../context/DataProvider/DataProvider';
import LayoutProvider from '../../context/LayoutProvider/LayoutProvider';

// components 
import { App } from '../../components';
import Header from "../../components/Header"
import Footer from '../../components/Footer/Footer';
import NioBackTop from '../../components/NioBackTop/NioBackTop';
import NioStickyBadge from '../../components/NioStickyBadge/NioStickyBadge';
import { useTranslation } from '../../i18n/I18nProvider';
import { translateNavData } from '../../i18n/translateNav';

function getStoredUserRole() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '';
    const u = JSON.parse(raw);
    return String(u?.role || '').trim().toLowerCase();
  } catch {
    return '';
  }
}

function AppLayout({ variant = 2, rootClass, title = 'page title goes here', children }) {

  const data = useData();
  const location = useLocation();
  const { t, language } = useTranslation();

  // get navigation data 
  const navigation = data.navigation;
  const baseHeaderData = location.pathname === "/" ? navigation.one : navigation.two;

  // Filtre la navigation suivant le role utilisateur :
  // - l'admin n'a pas a voir le lien "Service apres-vente" (il gere depuis son dashboard)
  const headerData = useMemo(() => {
    const role = getStoredUserRole();
    let nav = baseHeaderData;
    if (!nav) return nav;
    if (role === 'admin') {
      const hideForAdmin = (url) => {
        const u = String(url || '').toLowerCase();
        return u === '/support-sav' || u === '/service-apres-vente';
      };

      const filteredMenus = (nav.menus || [])
        .filter((m) => !hideForAdmin(m?.item?.url))
        .map((m) => {
          const submenu = m?.item?.submenu;
          if (!submenu || !Array.isArray(submenu.items)) return m;
          return {
            ...m,
            item: {
              ...m.item,
              submenu: {
                ...submenu,
                items: submenu.items.filter((it) => !hideForAdmin(it?.url)),
              },
            },
          };
        });

      nav = { ...nav, menus: filteredMenus };
    }

    return translateNavData(nav, t);
  }, [baseHeaderData, location.pathname, t, language]);

  useEffect(() => {
    document.title = `${title} - Alo Alla`
  }, [title])

  return (
    <LayoutProvider>
      <App rootClass={rootClass}>
        <Header variant={variant} data={headerData} />
        <App.Main>
          {children}
        </App.Main>
        <Footer variant={variant} />
        <NioBackTop />
        <NioStickyBadge />
      </App>
    </LayoutProvider>
  )
}

export default AppLayout;
